import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';

export const forAreaRugs = (Component) => (props) => {
  const {
    segment,
  } = useContext(ExperienceContext);

  if (segment !== 'area-rugs') return null;
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component {...props} />;
};